import store from '@/store'

export default {
    getToken() {
        return localStorage.getItem('cfma-token')
    },

    getRefreshToken() {
        return localStorage.getItem('cfma-refresh-token')
    },

    async setConfigurations(user) {
        await store.dispatch('session/setUser', user)
    },

    async saveSession(data) {
        localStorage.setItem('cfma-token', data[0].token)
        localStorage.setItem('cfma-refresh-token', data[0].refreshToken)

        await this.setConfigurations(data[0])
    },

    async switchToken() {
        localStorage.setItem(
            'cfma-token',
            localStorage.getItem('cfma-refresh-token')
        )
    },

    async removeSession() {
        let token = this.getToken()
        let refreshToken = this.getRefreshToken()

        if (token || refreshToken) {
            localStorage.removeItem('cfma-token')
            localStorage.removeItem('cfma-refresh-token')
        }

        store.dispatch('integrations/clearErpIntegration', null)
        await store.dispatch('session/setUser', null)
    },
}
